<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "Role",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
